import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const isBillingReturnPath = (search) => {
    const params = new URLSearchParams(search);
    if (params.get("status") === "success" || params.get("status") === "cancel") return true;
    if (params.get("redirect_status") === "succeeded" || params.get("redirect_status") === "failed") {
        return true;
    }
    return false;
};

const isAdminShellPath = (pathname) =>
    pathname === "/dashboard" || pathname.startsWith("/admin");

export const useClearToastsOnMount = () => {
    const location = useLocation();
    useEffect(() => {
        if (isBillingReturnPath(location.search)) return;
        // AdminLayout owns billing toasts in a dedicated container — do not wipe them.
        if (isAdminShellPath(location.pathname)) return;
        try {
            toast.dismiss();
        } catch {
            // react-toastify can throw if toast state is out of sync during route changes
        }
    }, [location.pathname]);
};